import React, { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Select from '../../../../../components/form/Select'
import { MenuItem, Typography, withStyles } from '@material-ui/core'
import { compose } from 'redux'
import { Field, FormStateMap, InjectedFormProps, isInvalid, reduxForm } from 'redux-form'
import { getStyles } from 'isotope-client'
import FormButton from '../../../../../components/form/FormButton'
import { connect } from 'react-redux'
import { ConfigProps } from 'redux-form/lib/reduxForm'
import AutocompleteMulti from '../../../../../components/form/AutocompleteMulti'
import { formatChipLabelRessource } from '../../utils/ScheduleApiUtils'
import { ScheduleViewFiltersValues } from '../../services/schedule.types'
import { SchedulerFiltersFormName, useScheduler } from '../../context/SchedulerContext'
import { ELEMENTS_TO_DISPLAY } from '../../services/schedule.consts'

const Fields = {
	selectedRessources: { name: 'selectedRessources' },
	nbDays: { name: 'nbDays' }
}

/**
 * Styles
 */
const styles = () => getStyles({
	container: {
		display: 'flex',
		flexDirection: 'row' as 'row',
		alignItems: 'center'
	},
	inputContainer: {
		display: 'flex',
		flex: 1,
		flexDirection: 'row' as 'row',
		gap: '12px',
		alignItems: 'center'
	},
	nbDaysInputContainer: {
		marginBottom: 5
	},
	nbDaysInput: {
		paddingTop: 7
	},
	ressourcesContainer: {
		marginBottom: 5,
		width: '40%'
	},
	ressourcesInput: {
		paddingTop: '0px !important'
	}
})

type ScheduleFiltersProps = {
	classes: ClassNameMap,
}

const ScheduleFilters: FC<InjectedFormProps<ScheduleViewFiltersValues, ScheduleFiltersProps> & ScheduleFiltersProps> = ({ handleSubmit, classes }) => {
	const { formatMessage } = useIntl()
	const { viewInfos: { ressources }, ressourcesToDisplay } = useScheduler()
	const isRessourcesView = ressourcesToDisplay === ELEMENTS_TO_DISPLAY.RESSOURCES

	const getRessources = () => {
		const options = isRessourcesView ? ressources.filter((r) => r.active) : ressources
		return Promise.resolve(options.map((r) => ({
			code: r.id,
			chipLabel: formatChipLabelRessource(r.name),
			label: isRessourcesView
				? `${r.name} - ${r.role}`
				: `${r.name} - ${r.role} (${formatMessage({id: `schedule.filters.status.${r.active}` })})`
		})))
	}

	return (
		<form onSubmit={handleSubmit} className={classes.container}>
			<div className={classes.inputContainer}>
				<Typography variant="body1">
					<FormattedMessage id={`schedule.filters.${Fields.selectedRessources.name}`} />
				</Typography>
				<Field
					name={Fields.selectedRessources.name}
					component={AutocompleteMulti}
					getOptions={getRessources}
					formName={SchedulerFiltersFormName}
					inputRootClassName={classes.ressourcesInput}
					containerClassName={classes.ressourcesContainer}
					forceGetOptions
					disableCloseOnSelect
				/>
				<Typography variant="body1">
					<FormattedMessage id={`schedule.filters.${Fields.nbDays.name}`} />
				</Typography>
				<Field
					name={Fields.nbDays.name}
					component={Select}
					containerClassName={classes.nbDaysInputContainer}
					selectClassName={classes.nbDaysInput}
				>
					{
						[...Array(7)].map((_, index) => (
							<MenuItem key={index} value={index + 1}>
								<Typography variant="body1">
									{index + 1}
								</Typography>
							</MenuItem>
						))
					}
				</Field>

			</div>
			<FormButton
				formName={SchedulerFiltersFormName}
				type="primary"
				style={{
					height: 36,
					minWidth: 'auto',
					paddingLeft: 20,
					paddingRight: 20,
					marginRight: 35
				}}
				getDisabledFromState={(state: FormStateMap) => isInvalid(SchedulerFiltersFormName)(state)}
				disabled={false}
				keepCase
			>
				<FormattedMessage id="actions.filter" />
			</FormButton>
		</form>
	)
}

const mapStateToProps = ({}, { nbDays, selectedRessources }: ScheduleViewFiltersValues) => {
	return ({
		initialValues: {
			nbDays,
			selectedRessources
		}
	})
}

export default compose<FC<ConfigProps<Omit<ScheduleViewFiltersValues, 'selectedDate'>, ScheduleFiltersProps> & Omit<ScheduleViewFiltersValues, 'selectedDate'>>>(
	connect(mapStateToProps),
	reduxForm({
		form: SchedulerFiltersFormName,
		enableReinitialize: true
	}),
	withStyles(styles)
)(ScheduleFilters)

